import type { ReactElement } from 'react'
import './inboxItemRow.css'

export interface InboxItemRowProps {
  title: string
  body: string
  meta?: string | null
  unread?: boolean
  unreadLabel: string
  onClick?: () => void
  testId?: string
}

export const InboxItemRow = ({
  title,
  body,
  meta,
  unread = false,
  unreadLabel,
  onClick,
  testId,
}: InboxItemRowProps): ReactElement => {
  return (
    <button
      type="button"
      className={`inboxItemRow ${unread ? 'inboxItemRow--unread' : ''}`}
      onClick={onClick}
      data-testid={testId}
    >
      {unread && (
        <>
          <span className="inboxItemRow__unreadDot" aria-hidden="true" />
          <span className="inboxItemRow__visuallyHidden">{unreadLabel}</span>
        </>
      )}
      <div className="inboxItemRow__content">
        <div className="inboxItemRow__header">
          <span className="inboxItemRow__title">{title}</span>
          {meta && <span className="inboxItemRow__meta">{meta}</span>}
        </div>
        <p className="inboxItemRow__body">{body}</p>
      </div>
    </button>
  )
}
